import { render } from "./dashCreateSkillView.vue?vue&type=template&id=dca6e6e0"
import script from "./dashCreateSkillView.vue?vue&type=script&lang=js"
export * from "./dashCreateSkillView.vue?vue&type=script&lang=js"

import "./dashCreateSkillView.vue?vue&type=style&index=0&id=dca6e6e0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__